import React, { ReactNode } from "react";
import cx from "clsx";

export interface SubCategoryProps {
  title?: String | ReactNode;
  collapsed?: boolean;
  collapsible?: boolean;
  onEdit?(): void;
  onDelete?(): void;
  onCollapse?(): void;
}

export default ({
  title,
  collapsible = false,
  collapsed,
  onEdit = () => {},
  onDelete = () => {},
  onCollapse = () => {}
}: SubCategoryProps) => {
  return (
    <div className="card-box mb-2 p-2 d-flex">
      {collapsible && (
        <div className="d-flex align-items-center">
          <button className="btn action-icon waves-effect" onClick={() => onCollapse()}>
            {" "}
            <i className={cx("mdi", collapsed ? "mdi-chevron-down" : "mdi-chevron-right")}></i>
          </button>
        </div>
      )}

      <h4 className="font-16 flex-grow-1 ml-1">{title}</h4>

      <div className="d-flex align-items-center">
        <button className="btn action-icon waves-effect" onClick={() => onEdit()}>
          {" "}
          <i className="mdi mdi-square-edit-outline"></i>
        </button>
        <button className="btn action-icon waves-effect" onClick={() => onDelete()}>
          {" "}
          <i className="mdi mdi-delete"></i>
        </button>
      </div>
    </div>
  );
};
